<template>
  <panel title="Decyzje">
    <table class="table mt-5">
      <thead>
        <tr>
          <th v-for="(field, index) of fields" :key="'header_' + index">
            {{ field.title }}
          </th>

          <th>
            <span class="sr-only">Akcje</span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, rowIndex) of $schema.value.$items" :key="'row_' + rowIndex">
          <td v-for="(field, index) of fields" :key="'column_' + index">
            <w-datepicker v-if="item.$item[field.key].$schema.format === 'date'" title :model="item.$item[field.key]" />

            <w-input v-else title :model="item.$item[field.key]" />
          </td>

          <w-row-buttons
            class="middle"
            :model="item.$item"
            :move-up="rowIndex != 0"
            :move-down="item.$item.$parent.$value.length - 1 !== rowIndex"
          />
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="100%">
            <w-add-row class="btn-primary float-right" :model="$schema.value">
              Dodaj decyzję
            </w-add-row>
          </td>
        </tr>
      </tfoot>
    </table>

    <template slot="footer">
      <w-button class="btn-primary float-right" text="Zapisz" icon="fas fa-check" @click="submit" />
    </template>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import { DocumentValueCodes } from '@/enums/documentValueCodes.enum';
import { Successes } from '@/enums/successes.enum';
import { editMixin } from '@/mixins/edit';
import schema from '@/schemas/decisionList.schema';
import { tryParseInt } from '@/utils/number';

// @vuese
// Formularz listy decyzji
// @group Decistion
export default {
  components: { Panel },
  mixins: [editMixin('documentValue')],
  schema,

  computed: {
    ...mapState({
      stateData: state => state.documentValue.data || { value: [] }
    }),

    id() {
      return this.stateData.id;
    },

    fields() {
      const properties = schema.properties.value.items.properties;
      return Object.keys(properties).map(key => ({ ...properties[key], key }));
    }
  },

  methods: {
    // @vuese
    // Dodaje pola wartości dokumentu do modelu
    prepareModel(model) {
      model.code = DocumentValueCodes.DECISIONS;
      model.documentId = tryParseInt(this.$route.params.documentId);
      return model;
    },

    // @vuese
    // Wyświetla notyfikację o zapisie listy decyzji
    afterSave(id) {
      this.notifySuccess(Successes.DECISIONS_SAVED);
      this.$store.commit('documentValue/setEntity', { id, ...this.prepareModel(this.$schema.$getData()) });
    }
  }
};
</script>
